import { ActionIcon } from '@mantine/core';
import { IconStar, IconStarFilled } from '@tabler/icons-react';

import styles from './FavoriteButton.module.scss';
import { Props } from './FavoriteButton.types';

const FavoriteButton = ({ onChange, isFavorite, disabled }: Props) => {
  return (
    <ActionIcon
      onClick={event => onChange(!isFavorite, event)}
      variant={'transparent'}
      disabled={disabled}
    >
      {isFavorite ? (
        <IconStarFilled className={styles.filled} size={20} />
      ) : (
        <IconStar className={styles.outlined} size={20} />
      )}
    </ActionIcon>
  );
};

export default FavoriteButton;
